export enum age {
  three = 'three',
  four = 'four',
  five = 'five',
  six = 'six',
  seven = 'seven',
  eight = 'eight'
}

export interface INormValue {
  mean: number
  std: number
}

export interface INormData {
  [age.three]: INormValue
  [age.four]: INormValue
  [age.five]: INormValue
  [age.six]: INormValue
  [age.seven]: INormValue
}

export interface INormWeight {
  [age.three]: number
  [age.five]: number
  [age.six]: number
  [age.seven]: number
  [age.eight]: number
}



// WEBPACK FOOTER //
// ./src/data/abitilies/interfaces/INormData.ts